import { computed } from 'vue'
import type { IEntityPosition } from '~/components/entity/base-entity'

interface EntityHighlight {
  highlight?: boolean
  featured_positions?: Record<IEntityPosition, boolean>
}

/**
 * Composable for checking if an entity card should be highlighted based on its highlight status or featured position
 */
export const useEntityHighlight = (item: EntityHighlight, position?: IEntityPosition) => {
  return computed(() => {
    return item.highlight || (position && item.featured_positions?.[position])
  })
}
